import classnames from 'classnames'
import React, { ReactNode } from 'react'

interface ITitleProps {
  className?: string
  isBold?: boolean
  isRed?: boolean
  children: ReactNode
}

export const Title = (props: ITitleProps) => {
  const { isBold = false, isRed = false, className = '' } = props
  const classNames = classnames(
    'def-lst__tit',
    {
      'def-lst__tit--bold': isBold,
      red: isRed,
    },
    className,
  )

  return <span className={classNames}>{props.children}</span>
}
